import React from 'react';
import { ChakraProvider, Box, Flex } from '@chakra-ui/react';
import theme from './theme';
import MortgageCalculator from './components/MortgageCalculator';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

function App() {
  return (
    <ChakraProvider theme={theme}>
      <Flex minH="100vh" direction="column">
        <Navbar />
        <Box flex="1" pt="90px">
          <MortgageCalculator />
        </Box>
        <Footer />
      </Flex>
    </ChakraProvider>
  );
}

export default App; 